import { IBrand } from "./../ibrand";

export const Brand: IBrand = {
  navbarTitle: 'Goodgames',
  brandTitle: 'Goodgames',
  brandName: "goodgames",
  mockBackendUrl: 'https://si-test.preventor-player-ui-backend-mock.silabs.se',
  prodBackendUrl: 'https://si-test.preventor-player-ui-backend-mock.silabs.se',
  dialogUrl: 'assets/dialogs/',
  targetOrigin: '*',
  defaultLocale: 'en-GB',
  supportedLocales: ['en-GB'],
  messagesEnabled: true,
  showQuestionCounter: false,
  nextButtonInQuestion: false,
  resultLayout: 'separate',
  selfAssessmentFirst: false,
  tipsLayout: 'grid',
  cmsMockUrl: 'https://si-sandbox.orchard.silabs.se',
  cmsProdUrl: 'https://si-sandbox.orchard.silabs.se',
  cmsMockApiKey: 'ABCD1234',
  cmsProdApiKey: ''
};
